const KEY = "mindset.auth.return.v1";
const TTL = 30 * 60 * 1000;
const PATHS = new Set(["/docs", "/dashboard", "/tenant-admin", "/team", "/messages", "/superadmin", "/security"]);
export function authSignInHref() {
  const destination = safeAuthReturn(window.location.pathname + window.location.search + window.location.hash);
  return "/access?mode=signin" + (destination ? `&returnTo=${encodeURIComponent(destination)}` : "");
}
export function safeAuthReturn(value: unknown): string | null {
  if (typeof value !== "string" || !value || value.length > 2048 || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u0020\u007f]/u.test(value)) return null;
  try {
    const decoded = decodeURIComponent(value);
    if (/[\\\u0000-\u0020\u007f]/u.test(decoded) || decoded.startsWith("//")) return null;
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin && PATHS.has(url.pathname) ? url.pathname + url.search + url.hash : null;
  } catch { return null; }
}
export function rememberAuthReturn(search = window.location.search) {
  const query = new URLSearchParams(search);
  if (!query.has("returnTo")) return;
  const destination = safeAuthReturn(query.get("returnTo"));
  try {
    window.sessionStorage.removeItem(KEY);
    if (destination) window.sessionStorage.setItem(KEY, JSON.stringify({ destination, expiresAt: Date.now() + TTL }));
  } catch { /* Storage restrictions must not prevent sign-in. */ }
}
export function consumeAuthReturn(fallback = "/dashboard") {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    if (raw && raw.length <= 4096) {
      const record = JSON.parse(raw);
      if (record && Number.isSafeInteger(record.expiresAt) && record.expiresAt > Date.now() && record.expiresAt <= Date.now() + TTL) return safeAuthReturn(record.destination) ?? fallback;
    }
  } catch { /* Invalid or unavailable state uses the ordinary landing page. */ }
  return fallback;
}
